import React from "react";

const LowStock = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="low-stock-icon"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      fill="#EA9D3F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 11H9V13H7V11ZM7 3H9V9H7V3Z"
      fill="white"
    />
  </svg>
);

export default LowStock;
